var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-dots"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 15.5C11 14.9477 11.4477 14.5 12 14.5C12.5523 14.5 13 14.9477 13 15.5C13 16.0523 12.5523 16.5 12 16.5C11.4477 16.5 11 16.0522 11 15.5ZM16 16.5C16.5523 16.5 17 16.0522 17 15.5C17 14.9478 16.5523 14.5 16 14.5C15.4477 14.5 15 14.9477 15 15.5C15 16.0523 15.4477 16.5 16 16.5ZM8 16.5C8.5523 16.5 9 16.0522 9 15.5C9 14.9478 8.5523 14.5 8 14.5C7.4477 14.5 7 14.9477 7 15.5C7 16.0523 7.4477 16.5 8 16.5ZM22 8V18C22 20.2061 20.2061 22 18 22H6C3.7939 22 2 20.2061 2 18V8C2 5.7939 3.7939 4 6 4H7V3C7 2.4473 7.4473 2 8 2C8.5527 2 9 2.4473 9 3V4H15V3C15 2.4473 15.4473 2 16 2C16.5527 2 17 2.4473 17 3V4H18C20.2061 4 22 5.7939 22 8ZM20 11H4V18C4 19.1025 4.8975 20 6 20H18C19.1025 20 20 19.1025 20 18V11Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.e3c820acc6bd627209448c802a49172b.svg";
export { ForwardRef as ReactComponent };